let actions = {
    async fetchSongs( { commit } ) {
        const quickSearchXhr = new XMLHttpRequest();
        quickSearchXhr.open('GET', '/data/items.php?format=json', true);
        quickSearchXhr.setRequestHeader('Content-Type', 'application/json');
        quickSearchXhr.send();
        quickSearchXhr.onloadend = function () {
            commit("UPDATE_SONGS",  JSON.parse(quickSearchXhr.response));
        }
    },
    setTooltipText({ commit }, value) {
        commit('UPDATE_TOOLTIP', value)
    }
};

export default actions;